import { Chip } from "@mui/material";

type TipoAnuncio = "N" | "L" | "C" | "P" | "";

export const tipoAnuncioChip = (tipo: TipoAnuncio) => {
  const map = {
    N: {
      label: "Venda",
      color: "#22c55e", // verde
      bg: "#dcfce7",
    },
    L: {
      label: "Leilão",
      color: "#3b82f6", // azul
      bg: "#dbeafe",
    },
    C: {
      label: "Cotação",
      color: "#f59e0b", // amarelo
      bg: "#fef3c7",
    },
    P: {
      label: "Combo",
      color: "#8b5cf6", // roxo
      bg: "#ede9fe",
    },
    "": {
      label: "Venda",
      color: "#22c55e", // verde
      bg: "#dcfce7",
    },
  };

  const item = map[tipo];

  return (
    <Chip
      label={item.label}
      size="small"
      sx={{
        fontSize: "0.7rem",
        fontWeight: 600,
        color: item.color,
        backgroundColor: item.bg,
        borderRadius: "6px",
      }}
    />
  );
};
